import React from 'react';
import VideoTypeModal from '../../../../pages/course/components/class/lecture/components/VideoTypeModal.js';
import LectureVideoQuestion from '../../../../pages/course/components/class/lecture/LectureVideoQuestion.component.js';
import LectureTextQuestion from '../../../../pages/course/components/class/lecture/LectureTextQuestion.component.js';
import { FormulaModal } from '../FormulaModal';

interface QuestionResolutionModalsProps {
  modalVideoOption: boolean;
  setModalVideoOption: (value: boolean) => void;
  setIsLibrasVideo: (value: boolean) => void;
  questionVideoStart: boolean;
  setQuestionVideoStart: (value: boolean) => void;
  isLibrasVideo: boolean;
  videoEmbed?: string | null;
  videoEmbedLibras?: string | null;
  questionTextShow: boolean;
  setQuestionTextShow: (value: boolean) => void;
  questaoComentada?: string | null;
  formulaModalShow?: boolean;
  setFormulaModalShow?: (value: boolean) => void;
  formula?: string | null;
  formulaImagem?: string | null;
}

export const QuestionResolutionModals: React.FC<QuestionResolutionModalsProps> = ({
  modalVideoOption,
  setModalVideoOption,
  setIsLibrasVideo,
  questionVideoStart,
  setQuestionVideoStart,
  isLibrasVideo,
  videoEmbed,
  videoEmbedLibras,
  questionTextShow,
  setQuestionTextShow,
  questaoComentada,
  formulaModalShow,
  setFormulaModalShow,
  formula,
  formulaImagem,
}) => {
  return (
    <>
      {modalVideoOption && (
        <VideoTypeModal
          modalVideoOption={modalVideoOption}
          setModalVideoOption={setModalVideoOption}
          setLSBVideo={setIsLibrasVideo}
          setQuestionVideoStart={setQuestionVideoStart}
        />
      )}
      <LectureVideoQuestion
        questionVideoStart={questionVideoStart}
        setQuestionVideoStart={setQuestionVideoStart}
        videoEmbed={isLibrasVideo ? videoEmbedLibras : videoEmbed}
        setModalVideoOption={setModalVideoOption}
        setLSBVideo={setIsLibrasVideo}
      />
      <LectureTextQuestion
        questionTextShow={questionTextShow}
        setQuestionTextShow={setQuestionTextShow}
        text={questaoComentada}
      />
      {formulaModalShow !== undefined && setFormulaModalShow && (formula || formulaImagem) && (
        <FormulaModal
          visible={formulaModalShow}
          onClose={() => setFormulaModalShow(false)}
          formula={formula}
          formulaImagem={formulaImagem}
        />
      )}
    </>
  );
};

export default QuestionResolutionModals;
